import Vue from 'vue';
import VueAnalytics from 'vue-analytics';
import VueGtm from 'vue-gtm';
import { sync } from 'vuex-router-sync';
import Notify from 'klicknotify';
import UniversalNavigator2x from '@hotmart-org-ca/saas-pages-universal-navigator-2x';
import App from './App';
import router from './router';
import store from './store';
import i18n from './i18n';
import univesalNavigatorConfigs from './config/universal-navigator';
import rebrandConfigs from './config/rebrand';

sync(store, router);

Vue.config.productionTip = false;

Notify.init();

const VueApp = new Vue({
  router,
  store,
  i18n,
  rebrandConfigs,
  template: '<App/>',
  components: { App },
});

Vue.use(VueAnalytics, {
  id: process.env.ANALYTICS_ID.split(','),
  router,
  autoTracking: {
    page: process.env.NODE_ENV === 'production' || process.env.NODE_ENV === 'staging',
  },
});

Vue.use(VueGtm, {
  id: process.env.GTM_API_KEY.split(','),
  defer: false,
  enabled: true,
  loadScript: true,
  vueRouter: router,
});

Vue.use(UniversalNavigator2x, { store, i18n, configs: univesalNavigatorConfigs });

VueAnalytics.onScriptLoaded().then(() => {
  VueApp.$mount('#app');
});



// WEBPACK FOOTER //
// ./src/main.js